import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const ContinueCircleIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 25 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.645 11.5C21.645 16.7467 17.3593 21 12.0725 21C6.78576 21 2.5 16.7467 2.5 11.5C2.5 6.25329 6.78576 2 12.0725 2C17.3593 2 21.645 6.25329 21.645 11.5Z"
      stroke={color}
      strokeWidth="2.11111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14V13.25C9 11.5931 10.3431 10.25 12 10.25H15M15 10.25L12.75 12.5M15 10.25L12.75 8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
